export const requestLogin = (Popup: any, navigate: any) => {
  Popup.alert({
    title: '로그인이 필요합니다.',
    content: '로그인하러 가시겠습니까?',
    buttonArray: [
      {
        text: '로그인',
        color: 'blue',
        onClick: () => {
          navigate('/oauth/login');
        },
      },
      { text: '닫기', color: 'gray', onClick: () => {} },
    ],
  });
};
